module.exports = {
	// see: @babel/code-frame/lib/index.js
	grey: null,
	red: {
		bold: null,
	}
}
